export function getLogoWrapperPadding(isProductPickerEnabled: boolean): string {
  if (isProductPickerEnabled) {
    return '3px 30px 0 0'
  }

  return '15px 30px'
}
